import type { IControllerConstructor, IDirective, Injectable } from "angular";
import { module } from "angular";

import EnumFlagShowsDirectiveController from "./EnumFlagShowDirectiveController";

export default class EnumFlagShowDirective implements IDirective {
    public bindToController = {
        flagValue: "<mmEnumFlagShow",
        model: "=mmEnumFlagShowModel",
    };

    public controller: Injectable<IControllerConstructor>;

    public controllerAs = "$ctrl";

    public restrict = "A";

    public scope = {};

    constructor() {
        this.controller = EnumFlagShowsDirectiveController;
    }
}

module("mmModels").directive("mmEnumFlagShow", () => new EnumFlagShowDirective());
